import { render, staticRenderFns } from "./PageComponents.vue?vue&type=template&id=3c55b929"
import script from "./PageComponents.vue?vue&type=script&lang=js"
export * from "./PageComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports